module.exports = __webpack_public_path__ + "/content/skins/fusion/img/HappyBunch.png";